import React from "react";
import Navbar from "../../Components/Navbar";
import Header from "../../Components/Header";
import { Container, Typography } from "@mui/material";
import Footer from "../../Components/Footer";
import CallToEnroll from "../../Components/CallToEnroll";
import PageTitle from "../../Components/PageTitle";
import SportsBanner from "../../assets/Sports.png";

const Sports = () => {
  return (
    <>
      <Navbar />
      <PageTitle
        title="Sports & Physical Education - Shree Mangalam School"
        description="Explore the sports programs at Shree Mangalam School. We promote fitness, discipline, and teamwork through regular physical education and competitive sports."
        url="/sports"
        keywords="school sports, physical education, games, fitness activities, Shree Manglam sports, RIMC physical training"
      />

      <Header image={SportsBanner} alt={"Sports Banner image"} />

      <Container sx={{ mb: 5, mt: 5 }}>
        <Typography
          variant="h5"
          sx={{
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            fontSize: "30px",
            letterSpacing: 1,
            color: "#065A79",
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Sports
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 3,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we believe that sports are
          not just about winning medals — they’re about building character,
          discipline, and determination. Our comprehensive sports program is
          designed to nurture physical fitness, team spirit, and mental
          resilience in every student.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We offer regular training in a wide range of sports including cricket,
          football, kabaddi, volleyball, kho-kho, athletics, yoga, and indoor
          games such as chess and carrom. Our trained coaches provide
          personalized guidance and help students master techniques while
          promoting values of fair play, commitment, and perseverance.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          Each day at Shree Mangalam begins with morning fitness drills and
          warm-up sessions, ensuring students develop healthy routines and
          energetic starts. Regular inter-house matches and inter-school
          tournaments keep the spirit of competition alive while building
          confidence and leadership skills.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          One of the most awaited events of the year is our Annual Sports Day —
          a grand celebration of talent, teamwork, and school spirit. Parents,
          teachers, and students come together to cheer on participants, making
          it a day of pride and unforgettable memories.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          We are proud of our students who have brought accolades at district
          and state-level competitions, proving that determination and support
          can take talent to new heights. Their success inspires others and
          strengthens our belief that the playground teaches some of life’s most
          valuable lessons.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, sports are an essential pillar of our
          holistic education. Because we don’t just shape minds — we build
          champions for life.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            mt: 2,
            fontFamily: "Montserrat, sans-serif",
            fontOpticalSizing: "auto",
            fontStyle: "normal",
            letterSpacing: 1,
            lineHeight: "1.8rem",
          }}
        >
          At Shree Mangalam School, we don’t just teach — we
          inspire through every activity, every challenge, and every
          opportunity. Whether it’s on the sports field or in the classroom, we
          nurture courage, confidence, and character. Enroll now and let your
          child grow into a confident, capable, and compassionate individual —
          ready to take on the world.
        </Typography>
      </Container>
      <CallToEnroll />
      <Footer />
    </>
  );
};

export default Sports;
